import { createSlice } from '@reduxjs/toolkit';

import { datagridApiSlice } from './apiSlice/data-grid-api-slice';

const initialState = {
    searchOptions: {},
    search: {
        filters: [],
        columns: [],
        sorting: [],
    },
};

export const datagridSlice = createSlice({
    name: 'datagrid',
    initialState: initialState,
    reducers: {
        setSearchFilters: (state, action) => {
            state.search.filters = action.payload;
        },
        setSearchColumns: (state, action) => {
            state.search.columns = action.payload;
        },
        setSearchSorting: (state, action) => {
            state.search.sorting = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            datagridApiSlice.endpoints.getDGSearchOptions.matchFulfilled,
            (state, action) => {
                state.searchOptions = action?.payload || {};
            }
        );
    },
});

export const { setSearchFilters, setSearchColumns, setSearchSorting } =
  datagridSlice.actions;
export const selectSearchFilters = (state) => state.datagrid.search.filters;
export const selectSearchColumns = (state) => state.datagrid.search.columns;
export const selectSearchSorting = (state) => state.datagrid.search.sorting;
export const selectSearchOptions = (state) => state.datagrid.searchOptions;

export default datagridSlice.reducer;
